<template>
  <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M7.27353 4.97068V7.66613H10.3724L9.96898 10.9117H7.27353V19.2914H3.78962V10.9117H0.96582V7.66613H3.78962V4.98902C3.73794 3.99708 4.07156 3.02353 4.72079 2.27179C5.37002 1.52005 6.28464 1.04827 7.27353 0.955015C8.34752 0.868185 9.42675 0.868185 10.5007 0.955015V4.01719H8.42873C8.14934 3.99162 7.87117 4.07748 7.6548 4.25607C7.43843 4.43466 7.30139 4.69151 7.27353 4.97068Z"
        fill="currentColor"/>
  </svg>
</template>
